import TableToExcel from "@linways/table-to-excel";


export const exportExcel = (tableRef) => {
	TableToExcel.convert(tableRef);
}
